
import barba from '@barba/core';
import c3 from 'c3';

export default class{

	constructor(){
        this.pattern = ['#BA9C93','#DDC9C3','#988782']
        barba.hooks.once((data) => {
            this.init(data.next.container)
        })
        barba.hooks.after((data) => {
            this.init(data.next.container)
        });
    }
    init (el){
        
        const charts = el.querySelectorAll("[data-chart]")
        charts.forEach(c => {
            console.log(c)
            const id = c.getAttribute("id")
            const title = c.dataset.title
            const columns = JSON.parse(c.dataset.columns)
            if(Array.isArray(columns)){
                c3.generate({
                    bindto: '#' + id,
                    color: { pattern: this.pattern },
                    data: {
                        columns: columns,
                        type : 'donut',
                    },
                    tooltip: {
                        show: false
                    },
                    donut: {
                        title: title
                    }
                });
            }

        });


    }
   
}